import { Observable } from 'rxjs/Observable';
import { Model } from '../../api/model';
import { FieldMeta } from './field-meta.model';
import { FormModel } from '../../forms/form/models/form.model';

export class EntityModel extends Model {
    public id;
    public name;
    public icon;
    public dynamic;
    public type;
    public roles_permissions: Array<any>;

    public constructor(data: Object = {}) {
        super(data);
    }

    public fieldsMeta() {
        return this.hasMany(FieldMeta, 'fieldsMeta', {entityId: this.id});
    }

    public forms() {
        return this.hasMany(FormModel, 'forms', {entityId: this.id});
    }

    public convert() {
        return new Observable(observer => {
            observer.next('test');
        });
    }
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/entities/models/entity-model.ts